import type { App } from 'vue'
import { createPinia } from 'pinia'
import { useStoreGlobal } from './modules/global'
import { useStorePoint } from './modules/point'

export {
  useStoreGlobal,
  useStorePoint
}

export function useStore() {
  return {
    global: useStoreGlobal(),
    point: useStorePoint(),
  }
}

export function setupStore(app: App<Element>) {
  app.use(createPinia())
}
